import { OnBehalfTypes } from '../actions/onBehalfAction';

const defaultState = {
  isOnBehalf: false,
  isOnBehalfNewJoiner: false,
  isOnBehalfLeaver: false,
  userOnBehalf: null,
  isManager: false,
  pcOrderOBO: {
    isOnBehalf: false,
    userOnBehalf: null,
  },
  countryCodeSomeone: '',
};

const onBehalfReducer = (state = defaultState, action: any) => {
  const { isOnBehalf, userOnBehalf, isManager, pcOrderOBO, countryCodeSomeone, isOnBehalfNewJoiner, isOnBehalfLeaver } = action;
  switch (action.type) {
    case OnBehalfTypes.SET_COUNTRY_CODE_FOR_SOMEONE_ELSE:
      return {
        ...state,
        countryCodeSomeone: countryCodeSomeone.toLowerCase(),
      };

    case OnBehalfTypes.SET_IS_ON_BEHALF_OF:
      return {
        ...state,
        isOnBehalf,
      };
    case OnBehalfTypes.SET_IS_ON_BEHALF_OF_NEW_JOINER:
      return {
        ...state,
        isOnBehalfNewJoiner,
      };
    case OnBehalfTypes.SET_IS_ON_BEHALF_OF_LEAVER:
      return {
        ...state,
        isOnBehalfLeaver,
      };
    case OnBehalfTypes.SET_USER_ON_BEHALF_OF:
      return {
        ...state,
        userOnBehalf,
      };
    case OnBehalfTypes.SET_IS_MANAGER:
      return {
        ...state,
        isManager,
      };
    case OnBehalfTypes.SET_PC_ORDER_ON_BEHALF_OF:
      return {
        ...state,
        pcOrderOBO: {
          ...state.pcOrderOBO,
          ...pcOrderOBO,
        },
      };
    default:
      return state;
  }
}

export default onBehalfReducer;
